import { COMPANY_URL } from '@src/routes/company';
import Button from '@src/ui/elements/button/Button';

export default function ContactComplete() {
  return (
    <main className='flex h-full items-center justify-center bg-gray-50 px-6 py-10 lg:px-10 lg:py-6 sm:bg-transparent sm:px-5 sm:py-4'>
      <div className='flex w-full max-w-[1000px] flex-col items-center rounded-lg border border-solid border-gray-200 bg-white p-20 lg:p-6 sm:border-0 sm:bg-transparent sm:p-5'>
        <h1 className='text-center text-3xl font-medium text-primary-500'>
          お問い合わせいただき
          <br className='hidden sm:block' />
          誠にありがとう
          <br className='hidden sm:block' />
          ございます。
        </h1>
        <p className='mt-10 text-center'>
          お問い合わせいただき
          <br className='hidden sm:block' />
          誠にありがとうございます。
          <br />
          担当者よりご連絡差し上げますので、
          <br className='hidden sm:block' />
          少々お待ちください。
        </p>
        <div className='mx-auto mt-10 w-full max-w-[240px] text-center'>
          <Button
            href={COMPANY_URL.HOME}
            outline
            fullRounded
            fullWidth
          >
            トップページに戻る
          </Button>
        </div>
      </div>
    </main>
  );
}
